// ============================================
// SEO metadata per page - English
// ============================================
export const seoMeta = {
  '/': {
    title: 'Performance SEO & Affiliate Marketing Agency | go2digital',
    description: 'Drive organic traffic and monetize with proven affiliate systems. We build high-performing digital assets, not just campaigns.',
  },
  '/about/': {
    title: 'About Us - Platform Builders, Not an Agency | go2digital',
    description: 'go2digital builds, owns, and operates digital platforms. Learn how we evolved from a blog into an ecosystem of 5 live platforms across 3 markets.',
  },
  '/services/': {
    title: 'Services - SEO, Affiliate, Platform Dev & AI | go2digital',
    description: 'Four interconnected disciplines: SEO & Organic Growth, Affiliate Monetization, Platform Development, and AI Integration. Battle-tested on our own platforms.',
  },
  '/projects/': {
    title: 'Our Platforms - Proof of Execution | go2digital',
    description: 'Explore the digital platforms we built, own, and operate. 500K+ monthly visits, 5 live platforms, 3 markets. Real traffic. Real revenue. Real proof.',
  },
};
